import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { choose } from '../../store/setQuestions';
import { setComponent } from '../../store/sessionStatus';

import { AgeRange } from '../../utils/enums';

import ChangeDeviceWarning from '../../pop-ups/changeDeviceWarning/ChangeDeviceWarning';
import RotateDeviceWarning from '../../pop-ups/rotateDeviceWarning/RotateDeviceWarning';

import Button from '../../components/button/Button';
import Header from '../../components/header/Header';
import SplashScreen from '../splashScreen/SplashScreen';

import icon5 from '../../assets/images/icon5.webp';
import icon6 from '../../assets/images/icon6.webp';

import './ageSelectionScreen.css';

export default function AgeSelectionScreen() {
    const dispatch = useDispatch();

    const chooseAge = (questions) => {
        dispatch(setComponent('question'));
        dispatch(choose(questions));
    };

    return (
        <React.Fragment>
            <ChangeDeviceWarning />
            <RotateDeviceWarning />

            <SplashScreen />
            <div id="ageSelection">
                <Header />

                <div className="mainInfo">
                    <h1>Welcome</h1>

                    <p style={{ textTransform: 'unset' }}>
                        TO THE iNSTRUCKTA! <br /> ROAD SAFETY QUIZ
                    </p>

                    <img className="decorCar" src={icon5} alt="decor" />

                    <img className="decorPerson" src={icon6} alt="decor" />
                </div>

                <p>Please select your age</p>

                <div id="ageButtons">
                    <Link to="/quiz" onClick={() => chooseAge(AgeRange.Child)}>
                        <Button type={'squareButton'} text="5-7" />
                    </Link>

                    <Link to="/quiz" onClick={() => chooseAge(AgeRange.Junior)}>
                        <Button type={'squareButton'} text="8-11" />
                    </Link>

                    <Link
                        to="/quiz"
                        onClick={() => chooseAge(AgeRange.Teenager)}>
                        <Button type={'squareButton'} text="12-15" />
                    </Link>

                    <Link to="/quiz" onClick={() => chooseAge(AgeRange.Adult)}>
                        <Button type={'squareButton'} text="16+" />
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
}
